import { useCallback, useMemo, useRef } from "react";
import type { EventBusMessage } from "src/shared/eventbus/EventBusMessage";

type Notifier<T> = (message: EventBusMessage<T>) => void;

export const useEventBusNotifiers = <T>() => {
  const notifiersRef = useRef<Notifier<T>[]>([]);

  const notify = useCallback((message: EventBusMessage<T>) => {
    notifiersRef.current.forEach((notifier) => notifier(message));
  }, []);

  const register = useCallback((notifier: Notifier<T>) => {
    notifiersRef.current.push(notifier);
    return () => {
      const index = notifiersRef.current.indexOf(notifier);
      if (index !== -1) {
        notifiersRef.current.splice(index, 1);
      }
    };
  }, []);

  return useMemo(() => ({ notify, register }), [notify, register]);
};
